import api from "./core";

const basePath = "api/core/InsuranceCompanyPlans";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query() {
    return api.post(`${basePath}`, {});
  },
  create(data) {
    return api.put(`${basePath}`, data);
  }
};
